
window.shr = {
	'toggle':function(){
		shr.infoToggle('rewards-information-directory');
		if(	$('.rewards-toggle').hasClass('opened')){
			
			$('.rewards-toggle').removeClass('opened');
			$('.rewards-content').stop().fadeOut();
		}else{
			$('.rewards-content').stop().fadeIn();
			$('.rewards-toggle').addClass('opened');
			
		}
	},
	'points':function($hsci){
		
		$.post('https://member.kaysandkins.com/points',{'hsci':$hsci},function(data){
			
				$('.point-display').html(data.points);
				
				
			},"json");
	
	},
	'earn':function($tID,$type,$hc,$hsci,$url){
		
		$process = 1;
		
		if($url != 0 ){
			
			window.open($url,'_blank','width=600,height=400,resizable=yes,scrollbars=yes,status=yes');
			
		}
		
		
		$year = 0;
		$month = 0;
		$day = 0;
		$error = '';
		if($tID == 2){
			
			$year = $('#rewards-customer-year').val();
			$month = $('#rewards-customer-month').val();
			$day = $('#rewards-customer-day').val();
			
			if($year == 0 || $month == 0 || $day == 0){
				$process = 0;
				$error = 'birthday-error';
			}
			
			
		}
		
		if($process > 0 ){
			$.post('https://member.kaysandkins.com/earnrewards',{'tID':$tID,'type':$type,'hc':$hc,'hsci':$hsci,'year':$year,'month':$month,'day':$day},function(data){
				shr.points($hsci);
				$('#type-'+$tID).html(data.checked);
				
			
				window.location.reload();
			},"json");
		}else{
			$('.'+$error).fadeIn();
		}
		
	},
	'infoToggle':function($id){
		$('.rewards-information').stop().fadeOut();
		$('#'+$id).stop().delay(500).fadeIn();
		$('.errors').hide();
		if($id != 'rewards-information-directory'){
			$('.rewards-point-main').stop().fadeOut();
			$('.rewards-point-back').stop().delay(500).fadeIn();
		}else{
			$('.rewards-point-back').stop().fadeOut();
			$('.rewards-point-main').stop().delay(500).fadeIn();
			
		}
		
	},
	'back':function(){
		shr.infoToggle('rewards-information-directory');
		
		
	},
	'redeem':function($id,$hidv,$v,$hc,$hsci){
		$('#redeem-'+$id).fadeOut();
		$('#redeem-loading-'+$id).delay(500).fadeIn();
		
		$.post('https://member.kaysandkins.com/rewardsredeem',{'id':$id,'hidv':$hidv,'v':$v,'hc':$hc,'hsci':$hsci},function(data){
				shr.points($hsci);
				$('#redeem-loading-'+$id).hide();
				
				$('#redeemcode-'+$id).html(data.code);
				
				
			},"json");
		
	},
	'viewRedeem':function(){
		$('html, body').animate({
			scrollTop: $('.rewards-how-to-redeem').offset().top
		}, 500);
	},
	'footer':function(){
		
		const customerId = window.ShopifyAnalytics?.meta?.page?.customerId || null;
	
		$.post('https://member.kaysandkins.com/rewardsfooter',{'id':customerId},function(data){
			console.log(data);
			if(data.status > 0 ){
				$('body').append(data.html);
			}
		},"json");

	},
	'toggleFooter':function(){
		
	},
	'productAvailable':function(){
		const productId = meta.product.id || null;
		
		$.post('https://member.kaysandkins.com/availableStore',{'productID':productId},function(data){
			if(data.status > 0 ){
				$('[data-block-id="price"]').after(data.html);
			}

		},"json");

		
	}
}

$(function(){
shr.footer();
shr.productAvailable();


});

